import { Controller } from "@hotwired/stimulus";

// Generic pill-style tabs (same look as the dashboard "Vue pédagogique /
// Vue financière" switcher): active tab gets .btn-cta-shared, inactive
// tabs get .text-gray-500. Panels are matched by data-tab.
export default class extends Controller {
  static targets = ["tab", "content"];
  static values = { defaultTab: String };

  connect() {
    this.show(this.defaultTabValue || this.tabTargets[0]?.dataset.tab);
  }

  switchTab(event) {
    this.show(event.currentTarget.dataset.tab);
  }

  show(name) {
    if (!name) return;

    this.contentTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tab !== name);
    });

    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tab === name;
      tab.classList.toggle("btn-cta-shared", active);
      tab.classList.toggle("text-gray-500", !active);
    });
  }
}
